import { useState } from "react";
import { Label, Spinner } from "flowbite-react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";
import Mousetrap from "mousetrap";

import "./Create.css";

const backend = await new Backend().init();

export default function Create({ master_id, updateType }) {
  const userType = Number(localStorage.getItem("user_type") || 7);

  const [loading, setLoading] = useState(false);
  const [broker_username, setBroker_Username] = useState("");
  const [broker_name, setBroker_name] = useState("");

  const onCreate = () => {
    if (broker_username === "") {
      toast.error("Invalid Broker Username ");
    } else if (broker_name === "") {
      toast.error("Invalid Broker Name ");
    } else {
      setLoading(true);
      let data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        master_id: userType === 3 ? localStorage.getItem("id") : master_id,
        broker_username: broker_username,
        broker_name: broker_name,
      };

      backend.create_broker(data).then((r) => {
        setLoading(false);
        if (r.error === "False") {
          toast.success(r.message);
          setBroker_Username("");
          setBroker_name("");
          updateType(2);
        } else {
          toast.error(r.message);
        }
      });
    }
  };

  Mousetrap.bind("enter", function () {
    Mousetrap.unbind("enter");
    onCreate();
  });

  return (
    <div className="createUser">
      <div className="username">
        <div style={{ marginBottom: 10 }}>
          <Label className="label" value="Username" />
        </div>

        <input
          type="text"
          name="search"
          id="search"
          autoComplete="new-password"
          placeholder="Enter Broker Username"
          class="input hover-background bg-gray-50 border h-8 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
          value={broker_username}
          onChange={(e) => {
            setBroker_Username(e.target.value);
          }}
        />
      </div>
      <div className="name">
        <div style={{ marginBottom: 10 }}>
          <Label className="label" value="Name" />
        </div>

        <input
          type="text"
          name="search"
          id="search"
          autoComplete="new-password"
          placeholder="Enter Broker Name"
          class="input hover-background bg-gray-50 border h-8 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
          value={broker_name}
          onChange={(e) => {
            setBroker_name(e.target.value);
          }}
        />
      </div>
      <div onClick={onCreate} className=" btnSubmit">
        {loading ? <Spinner size="sm" /> : "Submit"}
      </div>
    </div>
  );
}
